import React from 'react';
import { PoseHud } from '../PoseHud/PoseHud';
import './PoseStage.css';

export function PoseStage({
  videoRef,
  canvasRef,
  isStreaming,
  videoUrl,
  sourceMode,
  fps,
  hasPoseDetected,
  isLoadingModel,
  angles,
  phaseData,
  isRecording,
  formattedDuration,
  isConverting,
  conversionProgress = 0,
  isPaused,
  autoClipEnabled,
  autoClipStatus,
  shotCount,
  dominantHand = 'right',
  isMirrored = false,
  onToggleDominantHand,
  cameraError,
  modelError,
  onVideoEnded,
}) {
  const errorMsg = cameraError || modelError;

  return (
    <div className="pose-stage">
      <video
        ref={videoRef}
        src={sourceMode === 'file' ? videoUrl || undefined : undefined}
        className={`pose-stage__video ${isStreaming ? 'pose-stage__video--active' : ''} ${
          isMirrored ? 'pose-stage__video--mirrored' : ''
        }`}
        playsInline
        muted
        autoPlay
        loop={sourceMode === 'file' && !isRecording && !autoClipEnabled}
        onEnded={onVideoEnded}
      />
      <canvas
        ref={canvasRef}
        className={`pose-stage__canvas ${isStreaming ? 'pose-stage__canvas--active' : ''} ${
          isMirrored ? 'pose-stage__canvas--mirrored' : ''
        }`}
      />

      <PoseHud
        fps={fps}
        hasPoseDetected={hasPoseDetected}
        isStreaming={isStreaming}
        isLoadingModel={isLoadingModel}
        angles={angles}
        phaseData={phaseData}
        isRecording={isRecording}
        formattedDuration={formattedDuration}
        isPaused={isPaused}
        autoClipEnabled={autoClipEnabled}
        autoClipStatus={autoClipStatus}
        shotCount={shotCount}
        dominantHand={dominantHand}
        onToggleDominantHand={onToggleDominantHand}
      />

      {errorMsg && (
        <div className="pose-stage__error-overlay">
          <p>{errorMsg}</p>
        </div>
      )}

      {isConverting && (
        <div className="pose-stage__converting-badge">
          MP4 변환 중... {Math.round(conversionProgress * 100)}%
        </div>
      )}

      {!isStreaming && !errorMsg && (
        <div className="pose-stage__placeholder">
          <h4 className="pose-stage__placeholder-title">
            {sourceMode === 'file'
              ? '동영상 파일을 업로드하여 재생 분석하세요'
              : 'AI 실시간 자세 분석 스튜디오'}
          </h4>
          <p className="pose-stage__placeholder-desc">
            {sourceMode === 'file'
              ? '업로드한 영상의 각 프레임별 33개 관절 뼈대를 실시간으로 추론합니다.'
              : '아래 [카메라 시작] 버튼을 눌러 측면 스켈레톤 추론을 시작하세요.'}
          </p>
        </div>
      )}
    </div>
  );
}
